import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useStatsStore = defineStore(
  'stats-store',
  () => {
    const periodCount = ref<number | null>(100)

    function setPeriodCount(n: number | null) {
      periodCount.value = n
    }

    return { periodCount, setPeriodCount }
  },
  { persist: true },
)
